<!-- 导航面包屑 -->
<template>
  <div class="nav">
    <div class="center-box">
      <p>
        会员中心&nbsp;&nbsp; > &nbsp;&nbsp;<span class="act">{{
          activeName
        }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { getActiveName, setActiveName, removeActiveName } from "@/utils/auth";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      activeName: "",
    };
  },
  //监听属性 类似于data概念
  computed: {
    activeItem2() {
      return this.$store.state.user.activeItem2;
    },
  },
  //监控data中的数据变化
  watch: {
    activeItem2(newValue, oldValue) {
      this.activeName = newValue;
    },
  },
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.activeName = getActiveName();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style lang="scss" scoped>
.nav {
  @media screen and (max-width: 950px) {
    display: none;
  }
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: left;
  font-size: 18px;
  color: #666666;
  background-color: #ffffff;
  p {
    padding-left: 15px;
    .act {
      color: #01458e;
      font-weight: 600;
    }
  }
}
</style>
